<template>
  <div class="app" v-if="!oldBrowser">
    <!-- Main Nav -->
    <ims-sidemenu />
    <!-- Modals -->
    <ims-profile-modal />
    <ims-driver-select-modal />
    <ims-new-league-modal />
    <ims-join-league-modal />
    <!-- <ims-join-league-modal /> -->
    <ims-manage-leagues-modal />
    <!-- Interact -->
    <ims-popmenu />
    <ims-toast />
    <!-- Routes -->
    <router-view></router-view>
    <!-- Offline Indicator -->
    <div class="offline-bar" v-if="!$store.state.online">
      No internet connection found.
    </div>
    <!-- Loading Screen -->
    <ims-loading-screen></ims-loading-screen>
  </div>
  <div v-else class="app not-support">
    <h1>Sorry 😕</h1>
    <p class="text-center">
      Fantasy Challenge does not support Internet Explorer. <br />Please use
      Edge, Chrome, Firefox or Safari.
    </p>
  </div>
</template>

<style lang="scss">
@import './scss/utils/variables';

.app.not-support {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.offline-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: red;
  z-index: 4000;
  font-size: 12px;
  color: #fff;
  text-align: center;
  padding: 2px 16px;
}
</style>

<script>
// Modules
import tick from './modules/tick/tick';

// Locally used Components
import IMSPopmenu from './components/popmenu/popmenu.vue';
import IMSToast from './components/toast/toast.vue';
import IMSSideMenu from './containers/side-menu/side-menu.vue';
import IMSProfileModal from './containers/profile/profile';
import IMSDriverSelectModal from './containers/driver-select-modal/driver-select-modal';
import IMSNewLeagueModal from './containers/leagues/new-league-modal';
import IMSJoinLeagueModal from './containers/join-league-modal/join-league-modal';
import IMSManageLeaguesModal from './containers/manage-leagues-modal/manage-leagues-modal';
import IMSLoadingScreen from './containers/loading/loading';

export default {
  components: {
    'ims-popmenu': IMSPopmenu,
    'ims-toast': IMSToast,
    'ims-sidemenu': IMSSideMenu,
    'ims-profile-modal': IMSProfileModal,
    'ims-driver-select-modal': IMSDriverSelectModal,
    'ims-new-league-modal': IMSNewLeagueModal,
    'ims-join-league-modal': IMSJoinLeagueModal,
    'ims-manage-leagues-modal': IMSManageLeaguesModal,
    'ims-loading-screen': IMSLoadingScreen
  },
  data() {
    return {
      oldBrowser: false
    };
  },
  methods: {
    async hideSplashscreen() {
      await tick(500); // wait 500 seconds
      document.body.classList.remove('uninitialized'); // remove uninitialized
      document.body.classList.add('app-ready'); // add ready
    }
  },
  created() {
    this.$User.onChange(change => {
      if (change == 'logged-in') {
        if (!this.$User.profile) {
          // Check that the users profile is good
          this.$store.dispatch('user/checkForProfile');
        } else {
          this.$router.go('/home');
        }
      }
    });
  },
  async mounted() {
    /** Listen for Changes on the User Object */
    // this.$User.init();
    this.$store.dispatch('user/init');
    this.$store.dispatch('races/init', this.$User);
    this.$store.dispatch('leagues/init', this.$User);
    /** Check if there is SSO URL params  */
    // this.$User.checkForSSOLogin();
    /** Hide Splash Screen */
    this.hideSplashscreen();
    /** watch for Internet connectivity */
    this.$store.dispatch('watch/connection');
    this.oldBrowser = this.$store.getters['user/isIE'];
  }
};
</script>
